import React, { useState } from "react";
import ForgotPasswordPage from "../../screens/ForgotPasswordPage";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import IForgotPassword from "../../core/contracts/IForgotPassword";
import { DO_RESET_PASSWORD } from "../../Fedx";
import { useHubx } from "../../HubX";

function ForgotPassword() {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const toastr = useSnackbar();
  const hub = useHubx();

  const doReset = async (emailData: IForgotPassword) => {
    try {
      setLoading(true);
      await hub.request(DO_RESET_PASSWORD, emailData);

      toastr.enqueueSnackbar(
        "Um e-mail foi enviado para o endereço " +
          emailData.email +
          ". Siga as instruções para redefinir sua senha.",
        {
          variant: "info",
        }
      );
      redirect();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("doReset -> error", error);
    }
    setLoading(false);
  };

  const doCancel = async () => {
    redirect();
  };

  const redirect = () => {
    history.push("/");
  };

  return <ForgotPasswordPage loading={loading} onSubmit={doReset} onCancel={doCancel} />;
}

export default ForgotPassword;
